
import React from 'react';
import { Button } from "@/components/ui/button";
import { Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <section className="bg-noordpink text-white py-16 px-6">
      <div className="container mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">
            Klaar om AI in je bedrijf te brengen?
          </h2>
          <p className="text-lg mb-8 opacity-90">
            Plan een gratis kennismakingsgesprek en ontdek wat AI voor jouw bedrijf kan betekenen.
            Geen technische kennis vereist en geen verplichtingen.
          </p>
          <Button className="bg-white text-noordpink hover:bg-gray-100 px-8 py-2" asChild>
            <Link to="/contact">
              <Calendar className="mr-2 h-5 w-5" />
              Plan je gratis gesprek
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
